import Vue from 'vue'
import Router from 'vue-router'
//import Home from './views/Home.vue'
import Login from './views/Login.vue'
//import Signup from './views/Signup.vue'
import Account from './views/Account.vue'
import Session from "@/components/Session.vue";
//import Plan from "@/components/Plan.vue";
//import Issues from "@/components/Issues.vue";
//import Notifications from "@/components/Notifications.vue";

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: { name: 'login' }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/account',
     // name: 'account',
      component:Account,
      children:[
        {
          name:'session',
          path:'',
          component:Session,
          meta: { requiresAuth: true }
        },
        {
          name:'plan',
          path:'plan',
          component:() => import('@/components/Plan.vue'),
          meta: { requiresAuth: true }
        },
        {
          name:'issues',
          path:'issues',
          component:() => import('@/components/Issues.vue'),
          meta: { requiresAuth: true }
        },
        {
          name:'notifications',
          path:'notifications',
          component:() => import('@/components/Notifications.vue'),
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('./views/Signup.vue')
    },
    {
      path:'/PasswordRecovery',
      name: 'PasswordRecovery',
      component: () => import('./components/ForgotPassword')
    },
    {
      path:'/VerifyCode',
      name:'VerifyCode',
      component: () => import('@/components/VerifyCodeChangePass')
    }
    //{
      //path: '/about',
      //name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      //component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
//}
  ]
})
